import { __decorate } from "tslib";
import React, { Component } from 'react';
import { Table, Button, notification } from 'antd';
import { connect } from '@souche-f2e/muji';
import { TableContainer } from '@/components';
import { dispatch } from '@@/store';
import styles from '../_style/index.less';
import recallApprove from '../../RecallApprove';
import { selectedTable } from './function';
import Authorized from '@/components/Auth/auth';
import Mapping from '@/shared/mapping';
import { dealListValueShow } from '@/shared/functions';
import luban from '@souche-f2e/luban-js';
const mapStateToProps = (rootState) => ({
    approve: rootState.approve,
});
// @ts-ignore
let ApproveResultSuccess = class ApproveResultSuccess extends Component {
    constructor(props) {
        super(props);
        // desc 选中表格checkboxs
        this.onSelectedTableItem = (selectedRowKeys, selectedRows) => {
            selectedTable(selectedRowKeys, selectedRows, this.props.approve, 'Success');
        };
        // desc 撤回审批
        this.recall = (data) => {
            recallApprove(data, () => {
                dispatch.approve.updateTable({});
            });
        };
        // desc 表格跳页
        this.tableUpdate = (page, pageSize) => {
            dispatch.approve.updateTable({
                page,
            });
        };
        // desc 创建场次发拍
        this.session = () => {
            luban.send({
                eventType: 'click',
                typeId: 'PSGJB-CAR-QBSP-QBSPCG-CJCC',
            });
            const idList = this.props.approve.checkedKeySuccess;
            if (idList.length > 0) {
                dispatch.session.createSession({
                    idList,
                    routePath: '/ApproveManage/AllApproveManage/CreateSession',
                });
            }
            else {
                notification.warn({
                    message: '请至少选择一辆车再创建场次',
                });
            }
        };
        this.state = {
            colums: [
                {
                    title: '通过时间',
                    dataIndex: 'modifyTime',
                    align: 'left',
                },
                {
                    title: '操作',
                    dataIndex: 'operation',
                    align: 'left',
                    fixed: 'right',
                    width: 150,
                    render: (text, record, index) => (<div className={'table-operate-btn'}>
              <Authorized allow={this.props.approve.isMy ? 'psgjb-carthromine-withdraw' : 'psgjb-carthrough-withdraw'}>
                <a luban-id={this.props.approve.isMy ? 'PSGJB-CAR-QBSP-WDSPCG-CHSP' : 'PSGJB-CAR-QBSP-QBSPCG-CHSP'} onClick={(event) => {
                        this.recall(record);
                    }}>
                  撤回审批
                </a>
              </Authorized>
            </div>),
                },
            ],
            index: [
                {
                    title: '序号',
                    dataIndex: 'index',
                    fixed: 'left',
                    align: 'left',
                    width: 100,
                    render: (text, record, index) => {
                        const pageIndex = this.props.approve.pageIndexSuccess - 1;
                        return (<span>{(pageIndex * 20) + index + 1}</span>);
                    },
                },
            ],
        };
    }
    componentWillMount() {
        setTimeout(() => {
            const { activeTab } = this.props.approve;
            !activeTab && dispatch.approve.updateTable({ page: 1, acyiveKey: 'Success' });
        });
    }
    render() {
        const { tableSuccess, pageIndexSuccess, pageSizeSuccess, tableSuccessTotal, checkedKeySuccess, isMy, tableKey, loadingSuccess, exportParams, } = this.props.approve;
        const { tableColums } = this.props;
        const { index, colums } = this.state;
        return (<React.Fragment>
        <TableContainer totalNum={tableSuccessTotal} isTab exportObj={{
            type: 'goods',
            params: exportParams,
            fileName: `${isMy ? '我的' : '全部'}审批成功`,
            allow: isMy ? Mapping.exportAllow.psgjb_carthromine_export.value : Mapping.exportAllow.psgjb_carthrough_exporting.value,
        }}>
          <div className={styles.table_operate}>
            {!isMy && (<Authorized allow={'psgjb-carthrough-foundsession'}>
                <Button type="primary" onClick={this.session}>创建场次</Button>
              </Authorized>)}
          </div>
          <Table scroll={{ x: '170%' }} loading={loadingSuccess} rowKey={tableKey} columns={[...index, ...tableColums, ...colums]} dataSource={dealListValueShow({
            gistData: [...index, ...tableColums, ...colums],
            data: tableSuccess,
        })} rowSelection={isMy ? undefined : {
            selectedRowKeys: checkedKeySuccess,
            onChange: this.onSelectedTableItem,
        }} pagination={{
            current: pageIndexSuccess,
            defaultPageSize: pageSizeSuccess,
            showQuickJumper: true,
            total: tableSuccessTotal,
            onChange: this.tableUpdate,
        }}/>
        </TableContainer>
      </React.Fragment>);
    }
};
ApproveResultSuccess = __decorate([
    connect(mapStateToProps)
], ApproveResultSuccess);
export default ApproveResultSuccess;
